import React, { useState } from 'react';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Pills, Pill, TextLarge, Link } from '@hz-design-system/web-ui';

import Classes from './Scheduler.scss';
import { TTestDriveSchedulerOption } from 'types/TSellerPublicProfile';

type TSchedulerProps = {
  schedulerOptions: TTestDriveSchedulerOption[];
  onTestDriveSchedulerChange: (day: string, option: number) => void;
  selectedSchedulerOptions: {
    [key: string]: number[];
  };
};

const MAX_SCHEDULER_DAYS = 3;

const Scheduler = ({
  schedulerOptions = [],
  onTestDriveSchedulerChange,
  selectedSchedulerOptions,
}: TSchedulerProps) => {
  const { t } = useI18nContext();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(schedulerOptions.length > MAX_SCHEDULER_DAYS);

  const handleScheduleClick = (day: string, option: number): void => {
    if (onTestDriveSchedulerChange) {
      onTestDriveSchedulerChange(day, option);
    }
  };

  return (
    <div className={Classes.scheduler}>
      <Trans i18nKey={'testDriveScheduler.explainer'} className={Classes.explainer} />
      <Pills>
        {schedulerOptions?.map((option, dayIndex) => (
          <div
            key={option.dayOfWeek}
            className={`${Classes.schedulerDay} ${isCollapsed && dayIndex > MAX_SCHEDULER_DAYS - 1 ? Classes.hiddenSchedulerDay : ''}`}
          >
            <TextLarge className={Classes.dayHeading}>{t(`testDriveScheduler.${option.dayOfWeek}`)}</TextLarge>
            {option.timeSlots.map((slot, slotIndex) => (
              <Pill
                isActive={selectedSchedulerOptions[option.dayOfWeek].includes(slotIndex)}
                className={Classes.pill}
                key={option.dayOfWeek + slot.start}
                onClick={() => handleScheduleClick(option.dayOfWeek, slotIndex)}
                translations={{
                  ariaLabelDefault: t('testDriveScheduler.notSelected'),
                  ariaLabelActive: t('testDriveScheduler.selected'),
                }}
              >
                {`${slot.start} - ${slot.end}`}
              </Pill>
            ))}
          </div>
        ))}
      </Pills>
      {isCollapsed && (
        <div className={Classes.showMoreDays}>
          <Link onClick={() => setIsCollapsed(false)}>{t('testDriveScheduler.showMore')}</Link>
        </div>
      )}
    </div>
  );
};

export default Scheduler;
